import themeColor from './colors';

export default {
  themes: {
    light: themeColor,
  },
};
